import React from 'react';
import i18n from 'i18';
import {
    EmptyWalletTransparentBulkIcon,
    ProfileCircleBulkIcon
} from 'icons-lib';
import { Box, Typography } from '@mui/material';
import { AppDataContext } from '../../context/Context';
import PropTypes from 'prop-types';
import SearchBox from '../../search-box/SearchBox';

////////////////////////////
const icons = {
    walletNumber: <EmptyWalletTransparentBulkIcon />,
    toWallet: <EmptyWalletTransparentBulkIcon />,
    fromWallet: <EmptyWalletTransparentBulkIcon />,
    associatedWallet: <EmptyWalletTransparentBulkIcon />,
    owner: <ProfileCircleBulkIcon />,
    associatedMerchant: <ProfileCircleBulkIcon />,
    associatedPartner: <ProfileCircleBulkIcon />,
    default: <ProfileCircleBulkIcon />
};
export default class DialogAssociatedField extends React.Component {
    static contextType = AppDataContext;

    handleChangeAssociation = (value) => {
        if (this.props.field.kind) {
            this.props.onChange(
                this.props.field.id,
                value,
                this.props.data.kind
            );
        } else {
            this.props.onChange(this.props.field.id, value);
        }
    };

    render() {
        let items =
            this.context.getState().controllersData?.[this.props.field.from] ||
            [];
        let totalCount =
            this.context.getState().controllersData?.[
                this.props.field.from + 'TotalCount'
            ] || 0;
        const field = this.props.field;
        const { primary, secondary, multiple, primaryType, secondaryType } =
            field.associatedSettings;
        const primaryTitle = primary ? i18n.t(`columns.${primary}`) : '';
        const secondaryTitle = secondary ? i18n.t(`columns.${secondary}`) : '';

        const translatedLabel = i18n.t(`columns.${field.label}Details`) || '';

        const translatedSearchLabel = field.from
            ? i18n.t(`pages.${field.from}.title`)
            : '';

        const icon = icons[field.label] || icons.default;
        const addAssociationLabel = field.label
            ? i18n.t(`buttons.${field.label}Add`)
            : '';

        const required = this.props.field.required;
        const requiredLabel = required ? ' *' : '';

        return (
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2">
                    {translatedLabel + requiredLabel}
                </Typography>
                <SearchBox
                    serverSearch={this.props.field.searchType === 'server'}
                    searchFields={this.props.field.searchFields}
                    searchController={this.props.field.searchController}
                    handleChange={(value) =>
                        this.handleChangeAssociation(value)
                    }
                    icon={icon}
                    translatedLabel={translatedLabel}
                    multiple={multiple}
                    value={this.props.value}
                    primaryTitle={primaryTitle}
                    secondaryTitle={secondaryTitle}
                    primaryKey={primary}
                    secondaryKey={secondary}
                    primaryType={primaryType}
                    secondaryType={secondaryType}
                    items={items}
                    wrapperRef={this.props.wrapperRef}
                    addAssociationLabel={addAssociationLabel}
                    translatedSearchLabel={translatedSearchLabel}
                    totalItemsCount={totalCount}
                    hidePrimaryLabel={field.from === 'smeCompanies'}
                    hideSecondaryLabel={field.from === 'smeCompanies'}
                    stackValues={field.from === 'smeCompanies'}
                />
            </Box>
        );
    }
}
DialogAssociatedField.propTypes = {
    field: PropTypes.object.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    data: PropTypes.object,
    wrapperRef: PropTypes.object
};
